import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { t_Did, DidConfigService, t_Ecu } from 'src/app/services/apiHandler/did-config/did-config.service';
import { RoleService } from 'src/app/services/helper/role-handling-helper';

@Component({
    selector: 'app-did-mapping-table',
    templateUrl: './did-mapping-table.component.html',
    styleUrls: ['./did-mapping-table.component.scss'],
})
export class DidMappingTableComponent implements OnChanges {
    @Input() ecuDidMapping!: t_Ecu[];

    checkedList: any[] = [];
    public dataSet: MatTableDataSource<t_Did> = new MatTableDataSource<t_Did>();
    public selection: SelectionModel<t_Did> = new SelectionModel<t_Did>(true, []);
    public displayedColumns: string[] = ['checkbox','ecu_id', 'did', 'did_name', 'readWrite', 'readLevel', 'writeLevel' /*, 'unit', 'dataType'*/];

    constructor(private apiConnection: DidConfigService, private roleHandling: RoleService) {
        this.apiConnection.getDidQueryList().subscribe((resp) => {
            if(resp.body != null){
                let didList = JSON.parse(JSON.stringify(resp.body));
                this.dataSet.data.forEach(row => {
                    this.checkedList[row.did] = false;
                    for(let i = 0; i < didList.length; i++){
                        if(row.did ==  didList[i].data_id){  
                            this.selection.select(row);
                        }
                    }
                });
            }
        });
        this.apiConnection.getClearList().subscribe(() => {
            this.removeAll();
        });
    }

    @ViewChild(MatSort)
    sort!: MatSort;

    ngAfterViewInit() {
        this.dataSet.sort = this.sort;
      }

    ngOnChanges(changes: SimpleChanges): void {
        if ('ecuDidMapping' in changes) {
            this.ecuDidMapping = changes['ecuDidMapping'].currentValue;
            this.ecuDidMapping.forEach((mapping) => {
                mapping.ecu_dids.forEach((did) => {
                    did.ecu_id = mapping.ecu_id;
                });
            });
            this.ecuDidMapping.forEach((mapping) => {
                if(this.roleHandling.isRole('Expert')) {
                    this.dataSet.data = this.dataSet.data.concat(mapping.ecu_dids);
                    
                } else if(this.roleHandling.isRole('Basic')) {                   
                    this.dataSet.data = this.dataSet.data.concat(mapping.ecu_dids.map((did) => did).filter((did) => did.readLevel !== 'System'));
                }
            });            
        }
    }

    public isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSet.data.length;
        return numSelected === numRows;
    }

    public isFilteredSelected() {
        let counter = 0;
        this.dataSet.filteredData.forEach((data) => {
            if(this.selection.isSelected(data)){
                counter++;
            }
        });
        const numRows = this.dataSet.filteredData.length;
        return counter === numRows;
    }

    public masterToggle(event: any) {
        if(this.dataSet.data.length === this.dataSet.filteredData.length) {
            event.source.checked ? this.addToDisplay() : this.removeAll();
        } else {
            event.source.checked ? this.addFilteredToDisplay() : this.removeFiltered();
        }
    }

    public addToDisplay(){
        this.dataSet.data.forEach(row => {
            this.checkedList[row.did] = true;
            this.selection.select(row);
            let ecu_id = this.apiConnection.getEcuIdFromDID(row.did);
            this.apiConnection.addDidToQueryList({ ecu_id: ecu_id, data_id: row.did }).subscribe();
        });
    }

    public addFilteredToDisplay(){
        this.dataSet.filteredData.forEach(row => {
            this.checkedList[row.did] = true;
            this.selection.select(row);
            let ecu_id = this.apiConnection.getEcuIdFromDID(row.did);
            this.apiConnection.addDidToQueryList({ ecu_id: ecu_id, data_id: row.did }).subscribe();
        });
    }

    public removeAll(){
        this.selection.clear();
        this.dataSet.data.forEach(row => {
            this.checkedList[row.did] = false;
            let ecu_id = this.apiConnection.getEcuIdFromDID(row.did);
            this.apiConnection.removeDidFromQueryList({ ecu_id: ecu_id, data_id: row.did }).subscribe();
        });
    }

    public removeFiltered(){
        this.dataSet.filteredData.forEach(row => {
            this.checkedList[row.did] = false;
            this.selection.deselect(row);
            let ecu_id = this.apiConnection.getEcuIdFromDID(row.did);
            this.apiConnection.removeDidFromQueryList({ ecu_id: ecu_id, data_id: row.did }).subscribe();
        });
    }

    public didChecked(did: number, event: MatCheckboxChange) {
        const isChecked = event.checked;
        let ecu_id = this.apiConnection.getEcuIdFromDID(did);

        if (isChecked) {
            this.apiConnection.addDidToQueryList({ ecu_id: ecu_id, data_id: did }).subscribe();
            this.checkedList[did] = true;
        }
        if (!isChecked) {
            this.apiConnection.removeDidFromQueryList({ ecu_id: ecu_id, data_id: did }).subscribe();
            this.checkedList[did] = false;
        }
    }

    public applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSet.filterPredicate = function (data, filter: string): boolean {
            return (
                data.did.toString().includes(filter) ||
                data.did_name.toLowerCase().includes(filter.toLowerCase())
            );
        };
        this.dataSet.filter = filterValue.trim().toLowerCase();        
    }
}
